/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__trip_constraint = /** @type {(inputs: {}) => string} */ () => {
	return `Ihre Routeneinstellungen`
};

const en_itinerary__options__trip_constraint = /** @type {(inputs: {}) => string} */ () => {
	return `Your route preferences`
};

const es_itinerary__options__trip_constraint = /** @type {(inputs: {}) => string} */ () => {
	return `Tus preferencias en carretera`
};

const fr_itinerary__options__trip_constraint = /** @type {(inputs: {}) => string} */ () => {
	return `Vos préférences sur la route`
};

const it_itinerary__options__trip_constraint = /** @type {(inputs: {}) => string} */ () => {
	return `Le tue preferenze su strada`
};

const nl_itinerary__options__trip_constraint = /** @type {(inputs: {}) => string} */ () => {
	return `Uw voorkeuren onderweg`
};

const pt_itinerary__options__trip_constraint = /** @type {(inputs: {}) => string} */ () => {
	return `As suas preferências na estrada`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__trip_constraint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__trip_constraint(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__trip_constraint", locale)
	if (locale === "de") return de_itinerary__options__trip_constraint(inputs)
	if (locale === "en") return en_itinerary__options__trip_constraint(inputs)
	if (locale === "es") return es_itinerary__options__trip_constraint(inputs)
	if (locale === "fr") return fr_itinerary__options__trip_constraint(inputs)
	if (locale === "it") return it_itinerary__options__trip_constraint(inputs)
	if (locale === "nl") return nl_itinerary__options__trip_constraint(inputs)
	return pt_itinerary__options__trip_constraint(inputs)
};